/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * Modified MaterialRounded List (`grey-600`) overlaid with MaterialRounded Help Outline (`grey-600`).
 * @export
 */
export const ICON_LIST_WITH_HELP_OUTLINE = (
  <svg fill="none" height="176" viewBox="0 0 176 176" width="176" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 88C0 39.399 39.399 0 88 0s88 39.399 88 88v52c0 19.882-16.118 36-36 36H88c-48.601 0-88-39.399-88-88Z"
      fill="#F5F5F5"
    />
    <path
      d="M48 128h80c5.5 0 10-4.5 10-10s-4.5-10-10-10H48c-5.5 0-10 4.5-10 10s4.5 10 10 10Zm0-15h10v10H48v-10ZM38 58c0 5.5 4.5 10 10 10h80c5.5 0 10-4.5 10-10s-4.5-10-10-10H48c-5.5 0-10 4.5-10 10Zm20 5H48V53h10v10ZM48 98h80c5.5 0 10-4.5 10-10s-4.5-10-10-10H48c-5.5 0-10 4.5-10 10s4.5 10 10 10Zm0-15h10v10H48V83Z"
      fill="#707070"
    />
    <circle cx="131" cy="131" fill="#F5F5F5" r="29" />
    <path
      d="M131 106.833c-13.34 0-24.167 10.827-24.167 24.167 0 13.34 10.827 24.167 24.167 24.167 13.34 0 24.167-10.827 24.167-24.167 0-13.34-10.827-24.167-24.167-24.167Zm0 43.5c-10.658 0-19.333-8.676-19.333-19.333 0-10.658 8.675-19.333 19.333-19.333 10.657 0 19.333 8.675 19.333 19.333 0 10.657-8.676 19.333-19.333 19.333Zm-2.417-9.666h4.834v4.833h-4.834v-4.833Zm3.891-24.07a9.672 9.672 0 0 0-10.706 6.742c-.435 1.402.629 2.828 2.103 2.828h.483c.991 0 1.788-.701 2.127-1.62.773-2.15 3.069-3.625 5.558-3.093 2.296.483 3.988 2.731 3.794 5.075-.241 3.238-3.915 3.939-5.921 6.96 0 .024-.024.024-.024.048-.024.049-.048.073-.072.121a8.02 8.02 0 0 0-.604 1.209c-.025.072-.073.12-.097.193-.024.048-.024.097-.048.169-.29.822-.484 1.813-.484 3.021h4.834c0-1.015.265-1.861.676-2.586.049-.072.073-.145.121-.217.193-.339.435-.653.677-.943.024-.024.048-.072.072-.097.242-.29.508-.555.798-.821 2.32-2.199 5.461-3.988 4.809-8.604-.58-4.205-3.891-7.757-8.096-8.385Z"
      fill="#707070"
    />
  </svg>
);
